import axios from 'axios'
import store from '../store'
import config from '@/helpers/config'

export default {
  // App imports
  getRolesWithAll (context, payload) {
    return axios.get(
      config.apiUrl + '/roles/with-all?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getPlans (context, payload) {
    return axios.get(
      config.apiUrl + '/plans?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  // User data
  getOrganizationsWithAllById (context, payload) {
    return axios.get(
      config.apiUrl + '/organizations/with-all/by-id/' + payload.id + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUsersByOrganizationId (context, payload) {
    return axios.get(
      config.apiUrl + '/users/by-organization-id/' + payload.id + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUsersWithAllByOrganizationId (context, payload) {
    return axios.get(
      config.apiUrl + '/users/with-all/by-organization-id/' + payload.id + '?no_cache=' + (new Date()).getTime(),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  // Market
  getProjectsWithAllPublic (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all/public' + (payload != null ? payload + '&no_cache=' + (new Date()).getTime() : '?no_cache=' + (new Date()).getTime()),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectsWithAllAndStatsPublic (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all-and-stats/public' + (payload != null ? payload + '&no_cache=' + (new Date()).getTime() : '?no_cache=' + (new Date()).getTime()),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectsPublicWithAllFuzzy (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all/public/fuzzy/' + payload.searchValue + payload.query,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectsWithAllPublicCount (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/public/count' + (payload != null ? payload + '&no_cache=' + (new Date()).getTime() : '?no_cache=' + (new Date()).getTime()),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectsPublicFuzzyCount (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/public/count/fuzzy/' + payload.searchValue + (payload.query != null ? payload.query : ''),
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getOrganizationById (context, payload) {
    return axios.get(
      config.apiUrl + '/organizations/by-id/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  requestAccessToProject (context, payload) {
    return axios.post(
      config.apiUrl + '/users/request', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  // DIY && Subscription
  addProject (context, payload) {
    return axios.post(
      config.apiUrl + '/projects', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  addOrganizationProject (context, payload) {
    return axios.post(
      config.apiUrl + '/organizations-projects', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  addOrganizationUserProject (context, payload) {
    return axios.post(
      config.apiUrl + '/organizations-users-projects', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  addProjectPlans (context, payload) {
    return axios.post(
      config.apiUrl + '/project-plans', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectByName (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/by-name/' + payload.name,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  // Sign up
  addUser (context, payload) {
    return axios.post(
      config.apiUrl + '/users', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  // Access
  getOrganizationsWithAllByUserId (context, payload) {
    return axios.get(
      config.apiUrl + '/organizations/with-all/by-user-id/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateOrganizationProject (context, payload) {
    return axios.put(
      config.apiUrl + '/organizations-projects?no_cache=' + (new Date()).getTime(), payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteOrganizationProject (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/organizations-projects/' + payload.organizationId + '/' + payload.projectId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateOrganizationUser (context, payload) {
    return axios.put(
      config.apiUrl + '/organizations-users?no_cache=' + (new Date()).getTime(), payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateOrganizationUserProject (context, payload) {
    return axios.put(
      config.apiUrl + '/organizations-users-projects?no_cache=' + (new Date()).getTime(), payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateOrganization (context, payload) {
    return axios.put(
      config.apiUrl + '/organizations/' + payload.id, payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectPlans (context, payload) {
    return axios.get(
      config.apiUrl + '/projects-plans/by-project-id/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteOrganizationsUsersProjectsByOrganizationIdAndProjectId (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/organizations-users-projects/by-organization-id-and-project-id/' + payload.organizationId + '/' + payload.projectId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteOrganizationUserByOrganizationIdAndUserId (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/organizations-users/by-organization-id-and-user-id/' + payload.organizationId + '/' + payload.userId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  pushProjectToSlicer (context, payload) {
    return axios.put(
      config.apiUrl + '/project-to-slicer/' + payload.id + '?no_cache=' + (new Date()).getTime(), payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateProject (context, payload) {
    return axios.put(
      config.apiUrl + '/projects/' + payload.id + '?no_cache=' + (new Date()).getTime(), payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  updateUser (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.put(
      config.apiUrl + '/users/' + payload.id, payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  inviteUsers (context, payload) {
    return axios.post(
      config.apiUrl + '/users/invite', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteOrganizationsUsersProjects (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/organizations-users-projects/by-organization-id-and-user-id-and-project-id/' + payload.organizationId + '/' + payload.userId + '/' + payload.projectId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  deleteProject (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/projects/' + payload.projectId,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  // Login
  getUserByUuid (context, payload) {
    return axios.get(
      config.apiUrl + '/users/with-all/by-uuid/' + payload.uuid,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  userForgot (context, payload) {
    return axios.post(
      config.apiUrl + '/users/forgot', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  resetPassword (context, payload) {
    return axios.put(
      config.apiUrl + '/users/reset?no_cache=' + (new Date()).getTime(), payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getUserByEmail (context, payload) {
    return axios.get(
      config.apiUrl + '/users/by-email/' + payload.email,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getOrganizationByName (context, payload) {
    return axios.get(
      config.apiUrl + '/organizations/by-name/' + payload.organizationName,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  // Contact
  contact (context, payload) {
    return axios.post(
      config.apiUrl + '/users/contact', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  // Admin
  deleteAllProjectPlans (context, payload) {
    payload.token = store.getters['auth/currentToken']
    return axios.delete(
      config.apiUrl + '/projects-plans/by-project-id/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  activateProject (context, payload) {
    return axios.post(
      config.apiUrl + '/projects/activate', payload,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectWithAllById (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all/by-id/' + payload.id,
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getActiveProjectsWithAllByUserId (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all/by-user-id/' + payload.id + '?sortBy=_date_added&projectStatus=Active&order=DESC',
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getActiveProjectsWithAllByOrganizationId (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all/by-organization-id/' + payload.id + '?sortBy=_date_added&projectStatus=Active&order=DESC',
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectsWithAllByUserId (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all/by-user-id/' + payload.id + '?sortBy=_date_added&order=DESC',
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectsWithAllByOrganizationId (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all/by-organization-id/' + payload.id + '?sortBy=_date_added&order=DESC',
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  },
  getProjectsWithAllByCreatedByUserId (context, payload) {
    return axios.get(
      config.apiUrl + '/projects/with-all/by-created-by-user-id/' + payload.id + '?sortBy=_date_added&order=DESC',
      { headers: {'Authorization': 'Bearer ' + store.getters['auth/currentToken'], 'Content-Type': 'application/json; charset=UTF-8'} }
    )
  }
}



// WEBPACK FOOTER //
// ./src/store/actions.js